var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('tabs-layout',{attrs:{"config":_vm.detailsConfig,"create-mode":_vm.$route.query.category === 'request_new'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }